import { ref } from 'vue'

const largeScreenFitHeight = ref(false)

export default () => ({
  largeScreenFitHeight
})
